import React, {Component, createRef} from "react";
import PropTypes from "prop-types";
import {_upload} from "../../../../../services/apis/UploadServices";
import copyToClipboard from "copy-to-clipboard";

class UploadPage extends Component {
    file = createRef();
    input = createRef();

    state = {
        link: '',
        loading: false
    };

    _handleClick = (e) => {
        e.preventDefault();

        const data = new FormData();
        data.append('file', this.file.current.files[0]);

        this.setState({
            loading: true
        });

        _upload(data)
            .then(result => {
                const {data, success} = result;

                const updateState = {
                    loading: false
                };

                if (success) {
                    this.setState({
                        ...updateState,
                        link: data
                    });

                    copyToClipboard(data);

                    return;
                }

                this.setState(updateState);
            })
            .catch(error => {
                const message = error.message || error;

                alert(message);

                this.setState({
                    loading: false
                });
            });
    };

    _handleClickCopyUrl = () => {
        const {link} = this.state;
        copyToClipboard(link);

        this.input.current.select();
    };

    render() {
        const {link, loading} = this.state;

        return (
            <div className="UploadPage">
                <form className="form">
                    <div className="form-group">
                        <label htmlFor="file">File</label>
                        <input
                            ref={this.file}
                            id="file" type="file" className="form-control"/>
                    </div>
                    <button
                        disabled={loading}
                        onClick={this._handleClick}
                        id="upload" type="button"
                        className="btn btn-primary">
                        Upload
                    </button>

                    {
                        loading &&
                        <span>Uploading...</span>
                    }

                    {
                        !!link &&
                        <input
                            ref={this.input}
                            onClick={this._handleClickCopyUrl}
                            className="form-control" value={link} type="text"/>
                    }
                </form>
            </div>
        );
    }
}

UploadPage.propTypes = {
    any: PropTypes.any
};

export default UploadPage;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/upload/UploadPage/UploadPage.js